<template>
  <div class="printContainer">
    <!-- <button>Print this</button> -->
    <div class="printScreen">
      <div v-if="!printing">
        <img src="https://app.brighton.com/lockets/img/brighton_logo.jpg" alt="Brighton.com" class="logo">
          
          <div class="searchBox">
            <textarea v-model="searchBox" id="" cols="30" rows="10"></textarea>
            <button class="print" @click="searchOrders()">SEARCH</button>
          </div>
        
          <div class="confirmationNums">
            <button class="print" @click="printThis()">PRINT</button>
          </div>
      </div>  
      <div class="lockets">
        <div class="locket" :class="data.size" v-for="(data, index) in orders">
          <div class="confirmationNum">{{data.confirmationNum}}</div>
          <div v-if="data.size == 'l' || data.size == 's'">
            <!-- print left side-->
            <div class="img left" v-if="data.sides == 2">
              <span class="text" :class="{small: data.size=='s', large: data.size=='l'}" :style="{'font-family': data.userInputTextFontFamily2}"  v-if="data.userInputType2 == 2">
                <span :style="{'font-family': data.userInputTextFontFamily2}">{{data.userInputText4}}</span>
                <span :style="{'font-family': data.userInputTextFontFamily2}">{{data.userInputText5}}</span>
                <span :style="{'font-family': data.userInputTextFontFamily2}">{{data.userInputText6}}</span>
              </span>
              <img v-if="data.userInputType2 == 2" :src="data.styleImage2" :style="imageCSS(data)" alt="" class="left" @load="imageLoaded()"/>
              <div v-else>
                <img  v-if="data.settingJsonPreview2 == ''"  :src="data.previewFileName2" :style="imageCSS(data)" alt="" class="left" @load="imageLoaded()"/>
                <div class="hello" v-else :style="printImageCSS(data)" ><canvas :id = "data.canvasID+'leftSide'" ></canvas></div>
              </div>  
            </div>
            <!-- if one sided we want to print the right side twice-->
            <div class="img left" v-if="data.sides == 1 && data.size == 's'">
              <span class="text" :class="{small: data.size=='s', large: data.size=='l'}" :style="{'font-family': data.userInputTextFontFamily1}"  v-if="data.userInputType1 == 2">
                <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText1}}</span>
                <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText2}}</span>
                <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText3}}</span>
              </span>
              <img v-if="data.userInputType1 == 2" :src="data.styleImage1" :style="imageCSS(data)" alt="" class="right" @load="imageLoaded()"/>
              <div v-else>
                <img v-if="data.settingJsonPreview1 == ''"  :src="data.previewFileName1" :style="imageCSS(data)" alt="" class="right" @load="imageLoaded()"/>
                <div v-else :style="printImageCSS(data)" ><canvas :id = "data.canvasID+'rightSide1'" ></canvas></div>
              </div>
            </div>
            <div class="img right">
              <span class="text" :class="{small: data.size=='s', large: data.size=='l'}" :style="{'font-family': data.userInputTextFontFamily1}" v-if="data.userInputType1 == 2">
                <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText1}}</span>
                <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText2}}</span>
                <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText3}}</span>
              </span>
              <img v-if="data.userInputType1 == 2" :src="data.styleImage1" alt="" :style="imageCSS(data)" class="right" @load="imageLoaded()"/>
              <div v-else>
                <img v-if="data.settingJsonPreview1 == ''" :src="data.previewFileName1" :style="imageCSS(data)" alt="" class="right" @load="imageLoaded()"/>
                <div  v-else  :style="printImageCSS(data)" ><canvas :id = "data.canvasID+'rightSide'" ></canvas></div>
              </div>
            </div>
          </div>
          <div v-else-if="data.size == 'xl'">
              <div v-for="side in parseInt(data.sides)" class="img right" style="width: 100%;">
                <span class="text xlarge" v-if="data['userInputType' + (side)] == 2">
                  <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data['userInputText' + ((side + (2 * (side -1))) + 0)]}}</span>
                  <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data['userInputText' + ((side + (2 * (side -1))) + 1)]}}</span>
                  <span :style="{'font-family': data['userInputTextFontFamily'+side]}">{{data['userInputText' + ((side + (2 * (side -1))) + 2)]}}</span>
                </span>
                <img v-if="data['userInputType' + (side)] == 2" :src="data['styleImage'+(side)]" alt="" :style="imageCSS(data)"class="right" @load="imageLoaded()"/>
                <div v-else>
                  <img v-if="data['settingJsonPreview' + (side)] == ''" :src="data['previewFileName' + (side)]" :style="imageCSS(data)" alt="" class="right" @load="imageLoaded()"/>
                  <div :style="imageCSS(data)" v-else><canvas :id = "data.canvasID+'_oneSide'+(side-1)" ></canvas></div>
                </div>
              </div>
          </div>
          <div v-else-if="data.size == 'xxl'">
              <div class="img right" style="width: 100%;">
                  <span class="text xxlarge" v-if="data.userInputType1 == 2">
                    <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText1}}</span>
                    <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText2}}</span>
                    <span :style="{'font-family': data.userInputTextFontFamily1}">{{data.userInputText3}}</span>
                  </span>
                  <img v-if="data.userInputType1 == 2" :src="data.styleImage1" alt="" :style="imageCSS(data)" class="right" @load="imageLoaded()"/>
                  <div v-else>
                    <img v-if="data.settingJsonPreview1 == ''" :src="data.previewFileName1" :style="imageCSS(data)" alt="" class="right" @load="imageLoaded()"/>
                    <div :style="imageCSS(data)" v-else><canvas :id = "data.canvasID+'_oneSide'" ></canvas></div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Print',
  props: {
    // msg: String
  },
  data: function () {
    return {
      loading: false,
      imagesLoaded: 0,
      confirmationNums: '',
      orders: null,
      leftLocket: '',
      showPrintBtn: true,
      rightLocket: '',
      printWidth: 0,
      userInputText1:'',
      userInputText2:'',
      userInputText3:'',
      userInputText4:'',
      userInputText5:'',
      userInputText6:'',
      userInputTextFontFamily1:'',
      userInputTextFontFamily2: '',
      userInputType: 1,
      printing: false,
      searchBox: ''
    }
  },
  watch: {
    confirmationNums(newVal) {
      // this.confirmationNums = this.confirmationNums.trim();
    }
  },
  computed: {
    ordersSelected() {
      var num = 0
      if(this.orders != null) {
        this.orders.forEach((value) => {
          if(value.print === true) 
            num ++;
        })
      }
      return num
    },
    
  },
  methods: {
    printImageCSS(order) {
      if(order.printWidth != 0 && order.printWidth != null) {
        return {
          width: order.printWidth + 'cm',
          height: (order.printHeight != 0 ? order.printHeight : order.printWidth) + 'cm',
          margin: '0 auto'
        }
      } else {
        return {
          width: 'auto',
          height:'auto',
         margin: '0 auto'
        }
      }
    },
    searchOrders() {
      var that = this;
      if(this.searchBox.trim() != '') {
        this.confirmationNums = this.searchBox.trim().split("\t");
        this.confirmationNums.map(confirmationNum=>confirmationNum.trim())
        this.confirmationNums = this.confirmationNums.filter((item, pos) => {
            return this.confirmationNums.indexOf(item) == pos;
        })
        // console.log(searchConfirmationNums)
        this.loading = true;
        this.$http.post(
          'https://app.brighton.com/lockets/api/getOrders1',
          {
            
            confirmationNums: this.confirmationNums
          },
          {emulateJSON: true}
        ).then(response => {
          console.log(response)
          if(response.body.success) {
             let newOrders = []
            let returnedData = response.body.data
            this.confirmationNums.forEach((confirmationNum)=>{
              var found = returnedData.find((order) => {
                return order.confirmationNum == 'LOCKETS-'+confirmationNum || order.confirmationNum == confirmationNum
              })
              if(found) {
                found.canvasID = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
                newOrders.push(found)
              }
            })
            // console.log(newOrders)
            this.orders = newOrders
            this.$nextTick(()=>{
              this.orders.forEach((order) =>{
                
                if(order.size == 's' || order.size == 'l') {
                  if(order.settingJsonPreview1!= '')
                    this.setPreviewUserImgOne(0, order.canvasID + 'rightSide', order.settingJsonPreview1, order)
                  if(order.settingJsonPreview2!= '') {
                    this.setPreviewUserImgOne(1, order.canvasID + 'leftSide', order.settingJsonPreview2, order)
                  } else if (order.settingJsonPreview1!= '' && order.sides == 1 && order.size == 's'){
                    // if there's 1 side and the size is small..print the right side twice.
                    this.setPreviewUserImgOne(0, order.canvasID + 'rightSide1', order.settingJsonPreview1, order)
                  }
                }else if(order.size == 'xxl') {
                  if(order.userInputType1 != 2 ) 
                      this.setPreviewUserImgOne(0, order.canvasID + '_oneSide', order.settingJsonPreview1, order)
                } else if(order.size == 'xl') {
                  for(let side = 0; side < parseInt(order.sides); side ++) {
                    if(order['userInputType' + (side + 1)] != 2 ) 
                      this.setPreviewUserImgOne(side, order.canvasID + '_oneSide' + side, order['settingJsonPreview' + (side + 1)], order)
                  }
                }
              })
            })
          }  
          that.loading = false
        }, response => {
          that.loading = false
          console.log('something happened')
        });
        }
    },
    setPreviewUserImgOne(side=0, canvasID, jsonsetting, order){
      // console.log(jsonsetting)
      console.log('rending canvasID '+ canvasID)
      fabric.textureSize = 6144
      let canvas = new fabric.Canvas(canvasID)
      // let cavasID = side?'leftSide':'rightSide'
      jsonsetting = jsonsetting.substr(1)
      jsonsetting = jsonsetting.substring(0, jsonsetting.length -1)
      jsonsetting = JSON.parse(jsonsetting)

      // canvas.loadFromJSON(jsonsetting, canvas.renderAll.bind(canvas), (x)=> {
      canvas.loadFromJSON(jsonsetting, (x)=> {
        $('.canvas-container').css('max-width', '100%')
        canvas.setHeight(order['maskSizeHeight'] != 0 ? order['maskSizeHeight'] : order['maskSize'])
        canvas.setWidth(order['maskSize'])
        console.log(canvasID)
        document.querySelector("#"+canvasID).style.width = '100%'
        document.querySelector("#"+canvasID).style.height = '100%'
        let canvasContainers = document.querySelectorAll('.canvas-container')
        canvasContainers.forEach((canvasContainer) =>{
          canvasContainer.style.width = '100%'
          canvasContainer.style.height = '100%'
        })
        let upperCanvases = document.querySelectorAll('.upper-canvas')
        upperCanvases.forEach((upperCanvas) =>{
          upperCanvas.style.width = '100%'
          upperCanvas.style.height = '100%'
        })
      });
      canvas.on('after:render', console.log('after rendered '+canvasID))
    },
    imageLoaded() {
      console.log('image loaded')
      this.imagesLoaded += 1
      if((this.imagesLoaded / 2) == this.ordersSelected && this.printing) {
        this.$nextTick(function (){
          window.print()
          this.printing = false
        });
      }
    },
    printThis() {
      // this.printing = true
      // this.imagesLoaded = 0
      this.printing = true
      this.$nextTick(function (){
        window.print()
        this.printing = false
      });
    },
    imageCSS(locket) {
      if(locket.printWidth != 0 && locket.printWidth != null) {
        return {
          width: locket.printWidth + 'cm',
          height: (locket.printHeight > 0 ? locket.printHeight : locket.printWidth) + 'cm',
          margin: '0 auto'
        }
      } else {
        return {
          width: 'auto',
          height:'auto',
          margin: '0 auto'
        }
      }
    },
    pullOrders() {
      // this.confirmationNums = this.confirmationNums.trim();
      this.loading = true;
      var that = this;
      this.$http.post(
        'https://app.brighton.com/lockets/api/getOrders1',
        {
          
          confirmationNums: this.confirmationNums.split('\n')
        },
        {emulateJSON: true}
      ).then(response => {
        console.log(response)
        if(response.body.success) {
          // if the same orders appears twice ..print twice.
          let newOrders = []
          let returnedData = response.body.data
          this.confirmationNums.forEach((confirmationNum)=>{
            var found = this.returnedData.find((order) => {
              return order.confirmationNum == confirmationNum
            })
            if(found) {
              
              newOrders.push(found)

            }
          })
          console.log(newOrders)
          // this.$nextTick(() =>{
          //   if(this.data['userInputType1']!=2)
          //     this.setPreviewUserImgOne(0)
            
          //   if(this.data['userInputType2']!=2)
          //     this.setPreviewUserImgOne(1)
          // })
        }  
        that.loading = false
      }, response => {
        that.loading = false
        console.log('something happened')
      });
    },
   
    print() {
      this.showPrintBtn = false;
      this.$nextTick(function (){
        window.print()
        this.showPrintBtn = true;
      });
    },
  },
  mounted: function() {
    console.log('mounted print')
    // this.confirmationNums = 'AK38N\nNDPYW\nDH4RE\nFI1G2\nW17UA\nHFYG6\n0SD7U'
    // this.pullOrders()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media print and (max-width: 1170px) {

}
.printContainer{
  display:block;
  text-align:right;
  max-width:500px;
  margin:0 auto;
  /*border:1px solid #000;*/
}
.printContainer .printScreen .logo{
  display:block;
  width:40%;
  margin:20px auto;
}
.printContainer .printScreen{
  text-align:center;
  display:block;
  padding:10px;
  box-sizing: border-box;
  margin:0 auto;
  /*border:1px solid #999; */
}
.printContainer .printScreen{
  
}
.printContainer .printScreen hr{
  width:90%;
}
.printContainer .printScreen .searchBox{
  display:block;
}
.printContainer .printScreen .searchBox textarea{
  display:block;
  margin:0 auto;
  margin-bottom:4px;
  width:100%;
}
.printContainer .printScreen .locket{
    text-align: center;
    margin-top: 30px;
    padding-bottom:10px;
    display: block;
    border-bottom: 1px solid #ccc;
    /* height: 187px; */
    box-sizing: border-box;
    display: block;
    position:relative;
}
.printContainer .printScreen .locket:after{
  content: '';
  position:absolute;
  z-index:99;
  width:100%;
  height:100%;
  left:0;
  top:0;
}
.printContainer .printScreen .locket .selectToPrint{
  /* font-size: 20px; */
    float: left;
    width: 33px;
    height: 33px;
}
.printContainer .printScreen .locket:nth-child(3n),
.printContainer .printScreen .locket:last-child{
  page-break-after: always;
  border-bottom:none;
}

.printContainer .printScreen .locket.xl,
.printContainer .printScreen .locket.xxl {
  page-break-after:unset;
}

.printContainer .printScreen .locket.xl .img,
.printContainer .printScreen .locket.xxl .img{
  page-break-after:always;
  display:block;
}
.printContainer .printScreen .locket.xxl .img{
  page-break-before: always;
}


.printContainer .printScreen .locket .img{
  display:inline-block;
  width:40%;
  vertical-align: middle;
  position:relative;
}
.printContainer .printScreen .locket .img img{
  display:block;
  margin:0 auto;
}
.printContainer .printScreen .locket .img .text{
  position: absolute;
  left:0;
  text-align: center;
  font-size:0.9em;
  top:20%;
  width:100%;
  line-height:1.3;
}





.printContainer .printScreen .locket .img .text span{
  display:block;
}
.printContainer .printScreen .locket .img .text.xxlarge span{
  height: 50px;
  font-size: 54px;
}
.printContainer .printScreen .locket .img .text.xlarge span{
  height: 28px;
  font-size: 30px;
}
.printContainer .printScreen .locket .img .text.large span{
  height: 18px;
  font-size:13px;
}


.printContainer .printScreen .locket .img .text.xlarge {
  top: 28%;
}
.printContainer .printScreen .locket .img .text.xxlarge {
  top: 28%;
}

.printContainer .printScreen .locket .img .text.large{
  top:28%;
}

.printContainer .printScreen .locket .img .text.small{
  top: 32%;
}
.printContainer .printScreen .locket .img .text.small span{
  line-height: 10px;
  font-size: 10px;
  height: auto;
  font-weight:bold;
}



.printContainer .printScreen .locket .confirmationNum{
  display:block;
  width:auto;
  vertical-align: middle;
  /*margin-bottom:10px;*/
}





.printContainer .printScreen .confirmationNums{
  display:block;
}
.printContainer .printScreen .confirmationNums label{
  display:block;
  text-align: left;
}
.printContainer .printScreen .confirmationNums textarea {
  display:block;
  width:100%;
  height:100px;
  overflow-y: scroll;
  margin:10px auto;
  box-sizing: border-box;
}





.printContainer .title{
  font-weight: bold;
  display:block;
  font-size:20px;
  padding:0;
}

.printContainer .title .confirmationNum{
  color:#e03c7f;
}
.printContainer .instructions{
  text-align: left;
  margin-top:20px;
  margin-left:0;
  padding-left:0;
  list-style: none;
}
.printContainer .instructions li{
  padding:4px 0;
}
.printContainer .instructions .t1{
  font-weight: bold;
  display:block;
}
.printContainer .instructions .t2{
  display:block;
}
.printContainer .instructions .t3{
  display: block;
}

</style>
